import { TFunction } from 'i18next';
import * as yup from 'yup';

const GeneralSchema = (t: TFunction<'translations'>) => yup.object({
  dap: yup.string().required({ text: `${t('details.validation.tab')} ${t('details.esg.tab')}: ${t('details.validation.noData')} "${t('details.esg.lifeCycle.dapAcciona')}"`, optional: true, orden: 6 }),
}).required();

export default GeneralSchema;
